module.exports = __webpack_public_path__ + "img/login4.5d3a328e.png";